module.exports = __webpack_public_path__ + "img/Avatar-57.91f26305.svg";